
export const columnConfig = {
  name: {
    label: 'Grid Name',
    sortable: true,
    getText: s => s.name, 
  },
  template: {
    label: 'Grid Template',
    sortable: true,
    getText: s => s.gridName, 
  },
  version: {
    label: 'Version',
    sortable: true,
    getText: s => s.gridVersionName || '', 
  },
  usedIn: {
    label: 'Used In',
    sortable: true,
    getText: (s) => {
      const { documentUsage } = s;
      if (!documentUsage || !documentUsage.length) {
        return '';
      }

      let copy = documentUsage[0].document.name;
      if (documentUsage.length > 1) {
        copy += ` & ${documentUsage.length - 1} more`;
      }

      return copy;
    },
  },
  actions: {
    label: 'Actions'
  },
};